import { createSlice } from "@reduxjs/toolkit";


export const showPanierSlice = createSlice({
    name: 'showPanier',
    initialState:{},
    reducers: { // change shopping step to manage app navigation
       
        setShowPanier: (currentState, action) => {
            return action.payload;

        }
    }
});

